<template>
  <div>
    <h3 class="title mb-0">MENSAJERIA</h3>
    <div id="messages-body">
      <div class="box-message" v-for="message in messages" :key="message.id">
        <img class="avatar" :src="message.picture ? message.picture : '/static/img/avatar-placeholder.png'"/>
        <div class="message-text">
          <h3>{{ message.subject }}</h3>
          <article v-html="message.body"></article>
          <small class="date">{{ message.created_at | dateTime }}</small>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from '../http'

export default {
  name: 'Messages',
  data() {
    return {
      messages: []
    }
  },
  created() {
    this.loadMessages()
  },
  filters: {
    dateTime(value) {
      if (!value) return ''
      return new Date(value).toLocaleDateString('es-CL')
    }
  },
  methods: {
    loadMessages() {
      http.get('app/messages')
        .then(res => {
          this.messages = res.body.messages
        })
        .catch(err => {
          console.error('Error loading messages:', err)
        })
    }
  }
}
</script>

<style>

#messages-body .box-message .message-text article {
  word-wrap: break-word !important;
  overflow-wrap: break-word !important;
  max-width: 100% !important;
}

#messages-body .box-message .message-text article h4 {
  width: 100% !important;
  max-width: 100% !important;
  word-wrap: break-word !important;
  overflow-wrap: break-word !important;
}

#messages-body .box-message .message-text article p {
  max-width: 100% !important;
  word-wrap: break-word !important;
  overflow-wrap: break-word !important;
}

#messages-body .box-message .message-text article span {
  max-width: 100% !important;
  word-wrap: break-word !important;
  overflow-wrap: break-word !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/Messages.vue